export const btnSizeMap = {
  large: 'large',
  middle: 'default',
  small: 'small'
};

export const tableSizeMap = {
  large: 'default',
  middle: 'middle',
  small: 'small'
};

export const paginationSizeMap = {
  large: '',
  middle: '',
  small: 'small'
};

export const inputSizeMap = {
  large: 'large',
  middle: 'default',
  small: 'small'
};
